import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Grid, Header, Menu } from 'semantic-ui-react';
import './userProfile.css';
import { toTitleCase } from '../../app/common/util';
import EditProfileForm from './userForms/EditProfileForm';
import ChangePasswordForm from './userForms/ChangePasswordForm';
import { BrowserView, isBrowser } from 'react-device-detect';

const mapState = state => ({
  auth: state.auth,
  async: state.async
});

const actions = {};

class UserProfile extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    async: PropTypes.object.isRequired
  };
  state = {
    showProfile: true,
    pwd: false
  };

  showEditProfile = () => {
    this.setState({
      showProfile: true,
      pwd: false
    });
  };

  showEditPassword = () => {
    this.setState({
      showProfile: false,
      pwd: true
    });
  };

  handleItemClick = () => {
    alert('');
  };

  render() {
    const {
      auth: { profile }
    } = this.props;

    const { showProfile, pwd } = this.state;
    return (
      <div id="feature-user-profile">
        <Grid stackable>
          <BrowserView>
            <Grid.Row>
              <Grid.Column width={12}>
                <Header.Content as="h2">
                  {profile && toTitleCase(profile.name)}{' '}
                  {profile && toTitleCase(profile.lastName)}
                  <Header.Subheader as="span" className="email">
                    {profile && profile.email}
                    <Header.Subheader as="span" className="phone">
                      {profile && profile.mobileNo}
                    </Header.Subheader>
                  </Header.Subheader>
                </Header.Content>
              </Grid.Column>
            </Grid.Row>
          </BrowserView>

          <Grid.Row>
            <Grid.Column width={5}>
              <Menu
                vertical={isBrowser}
                stackable={isBrowser}
                pointing={isBrowser}
                compact={!isBrowser}
              >
                <Menu.Item
                  as="a"
                  name="inbox"
                  active={showProfile}
                  onClick={this.showEditProfile}
                >
                  Edit Profile
                </Menu.Item>

                <Menu.Item
                  as="a"
                  name="inbox"
                  active={pwd}
                  onClick={this.showEditPassword}
                >
                  Change Password
                </Menu.Item>
              </Menu>
            </Grid.Column>

            <Grid.Column width={10}>
              {showProfile && <EditProfileForm />}
              {pwd && <ChangePasswordForm />}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapState,
  actions
)(UserProfile);
